<template>
    <div v-if="plano" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Plano de Matrícula</h4>
        <router-link to="/cadastros/planos-matriculas">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <!-- Seção 1 -->
        <FormSection title="">
          <p><strong>Categoria:</strong> {{ plano.categoria_nome || 'Não informado' }}</p>
          <p><strong>Tipo de Plano:</strong> {{ plano.tipo_nome || 'Não informado' }}</p>
          <p><strong>Aulas por Semana:</strong> {{ plano.aulas_semana || 'Não informado' }}</p>
          <p><strong>Valor da Parcela:</strong> {{ formatCurrency(plano.valor_parcela) }}</p>
          <p><strong>Número de Parcelas:</strong> {{ plano.quantidade_parcelas || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ verificarAtivo(plano?.ativo) }}</p>
        </FormSection>
  
        <!-- Seção 2 -->
        <FormSection title="">
          <p><strong>Descrição:</strong> {{ plano.descricao || 'Não informado' }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        plano: null,
      };
    },
    methods: {
      async carregarDetalhesPlano() {
        try {
          const response = await axios.get(
            `/cadastros/planos-matriculas/${this.$route.params.id}`
          );
          const data = response.data;
  
          // Mapear o nome da categoria e tipo (caso não venham diretamente do backend)
          this.plano = {
            ...data,
            categoria_nome: data.categoria_nome || data.categoria || "Não informado",
            tipo_nome: data.tipo_nome || data.tipo || "Não informado",
          };
  
        } catch (error) {
          console.error("Erro ao carregar os detalhes do plano:", error);
        }
      },
  
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          return "Não informado";
        }
        return valor ? "Ativo" : "Inativo";
      },

      formatCurrency(value) {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
      },
    },
    mounted() {
      this.carregarDetalhesPlano();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%; /* Ajustado para centralizar melhor */
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
